import {IPoi} from "../types/IPoi";
import {TransportPoiType} from "./PoiType";

export const getClosestTransportPoi = (transportPois: Record<TransportPoiType, IPoi[]> | null): IPoi | null => {
    if (!transportPois || Array.isArray(transportPois)) {
        return null;
    }
    const busPoi = transportPois.bus?.[0] || null;
    const railwayPoi = transportPois.railway?.[0] || null;
    const subwayPoi = transportPois.subway?.[0] || null;
    const tramPoi = transportPois.tram?.[0] || null;

    const pois = [busPoi, railwayPoi, subwayPoi, tramPoi].filter((poi) => poi !== null);

    let closestPoi = null;
    if (pois.length > 0) {
        closestPoi = pois.reduce((minPoi, currentPoi) => {
            return currentPoi.distance < minPoi.distance ? currentPoi : minPoi;
        });
    }

    return closestPoi;
};
